var useHeadingStyles = function useHeadingStyles(_ref) {
  var size = _ref.size;

  switch (size) {
    case '3x-large':
      return {
        fontSize: '7x-large'
      };

    case '2x-large':
      return {
        fontSize: '6x-large'
      };

    case 'x-large':
      return {
        fontSize: '5x-large'
      };

    case 'large':
      return {
        fontSize: '4x-large'
      };

    case 'medium':
      return {
        fontSize: '3x-large'
      };

    case 'small':
      return {
        fontSize: '2x-large'
      };

    case 'x-small':
    default:
      return {
        fontSize: 'x-large'
      };
  }
};

export default useHeadingStyles;